import { UntilDestroy } from '@ngneat/until-destroy';
import { AppState } from 'src/app/@state/app.state';
import { Router } from '@angular/router';
import { AuthService } from './../services/auth.service';
import { Injectable } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	CanActivate,
	RouterStateSnapshot,
} from '@angular/router';
import { Store } from '@ngrx/store';

@UntilDestroy()
@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
	constructor(
		private authService: AuthService,
		private router: Router,
		private readonly store: Store<AppState>
	) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		if (this.authService.isLoggedIn()) {
			return true;
		} else {
			this.router.navigate(['']);
			return false;
		}
	}
}
